<template>
  <div class="py-4 container-fluid">
    <div class=" row">
      <div class="col-12">
        <authors-table />
      </div>
    </div>
    <div class="mt-4 row">
      <div class="col-12">
          <div class="card">
            <div class="card-header pb-0">
              <h6>Authors table</h6>
            </div>
            <div class="card-body px-0 pt-0 pb-2">
              <div class="table-responsive p-2">
        <DataTable
      :columns="columns"
      :ajax="ajaxOptions"
      class="table table-hover table-striped"
      width="100%"
      :options="options"
    >
      <thead>
        <tr>
          <th>ID</th>
          <th>Email</th>
          <th>Phone</th>
          <th>Joined at</th>
          </tr>
      </thead>
      
    </DataTable>
    </div>
    </div>
    </div>
      </div>
    </div>

    
  </div>
</template>

<script>
import AuthorsTable from "./components/AuthorsTable.vue";
import DataTable from 'datatables.net-vue3';
import DataTablesCore from 'datatables.net-bs5';


DataTable.use(DataTablesCore);
const API_URL = process.env.VUE_APP_API_BASE_URL;


export default {
  name: "tables",
  components: {
    AuthorsTable,
    DataTable
  },
  data() {
    return {
      ajaxOptions: {
      url: `${API_URL}/user/registrationdata`,
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      },
      dataSrc: (json) => {
        return json.data.listofregistrationdata
      },
      data: {},
    },
    options: {
      length: 1,
      pageLength: 1,
      serverSide: true
    },
      columns: [
  { data: 'id' },
  { data: 'username' },
  { data: 'phone' },
  { data: 'created_at' }
],
    };
  },
};
</script>


<style scoped>
@import "../assets/scss/argon-dashboard/plugins/pro/_datatable.scss";
@import "../assets/scss/argon-dashboard/plugins/pro/_datatable-extend.scss";

</style>